import mapKeys from 'lodash/mapKeys';
import map from 'lodash/map';

/**
 * Renames the keys of the availability object using the provided variables object
 *
 * @param {Object} availability
 * @param {Object} variables
 */
export function transformKeys(availability, variables) {
    return mapKeys(availability, (value, providerLocationId) =>
        getStoreKey(providerLocationId, variables)
    );
}

export function getStoreKey(
    providerLocationId,
    {
        insurancePlanId = '-1',
        isNewPatient = false,
        isReschedule = false,
        procedureId = '-1',
        timeFilter = 'AnyTime',
        widget = false,
    } = {}
) {
    // The availability service returns the same availability for plan ids -1 and -2,
    // so we should map them to the same availability.
    if (insurancePlanId === '-2') {
        insurancePlanId = '-1';
    }

    return map(
        {
            providerLocationId,
            insurancePlanId,
            isNewPatient,
            isReschedule,
            procedureId,
            timeFilter,
            widget,
        },
        (value, key) => `${key}:${value}`
    ).join('|');
}
